import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { Validators } from '@angular/forms';
import { ContributorTypeEnum } from 'src/app/domain/registration/enums/contributor-type.enum';
import { LegalPersonalityEnum } from 'src/app/domain/enums/legal-personality.enum';
import { PlanIndexSelectComponent } from '../../plans/crud-index/crud-index-select.component';
import { PlanSelectionWizardComponent } from '../../plans/plan-selection-wizard/plan-selection-wizard.component';
import { SystemTypeEnum } from 'src/app/domain/registration/enums/system-type.enum';
import { RegimeTypeEnum } from 'src/app/domain/registration/enums/regime-type.enum';
import { FiscalEnvironmentEnum } from 'src/app/domain/registration/enums/fiscal-environment.enum';

/**
 * Definição dos campos do formulário para o briefing de Cadastro de Cliente.
 */
export const REGISTER_CUSTOMERS_CONFIG: IFieldConfig[] = [
     
    //Tipo de CPF ou CNPJ
    {
        type: TypeComponentFieldEnum.SELECT,
        label: 'TIPO',
        name: 'legalPersonality',
        value: LegalPersonalityEnum.PESSOA_FISICA,
        options: Object.values(LegalPersonalityEnum),
    },

    //Nome do Cliente 
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Nome ', 
        name: 'name',
        validation: [Validators.required, Validators.minLength(4)],
      
    },
    //CPF
    {
        type: TypeComponentFieldEnum.INPUT_CPF,
        label: 'CPF', 
        name: 'cpf',
        validation: [Validators.minLength(11),Validators.required],
      
    },
     //CNPJ
    {
        type: TypeComponentFieldEnum.INPUT_CNPJ,
        label: 'CNPJ', 
        name: 'cnpj',
        validation: [Validators.minLength(14),Validators.required],
      
    },
    // rg - input
    {
        label: 'RG',
        name: 'generalRegistration',
        type: TypeComponentFieldEnum.INPUT_NUMBER,
        validation: [Validators.pattern(/\d+/),Validators.required],
    },
      // ie - input
    {
        label: 'IE',
        name: 'stateRegistration',
        type: TypeComponentFieldEnum.INPUT_NUMBER,
    },
    //Data de Nascimento
    {
        label: 'DATA DE NASCIMENTO',
        name: 'birthday',
        type: TypeComponentFieldEnum.INPUT_DATE,
        validation: [],
    },
    {
        label: 'RAZÃO SOCIAL',
        name: 'companyName',
        type: TypeComponentFieldEnum.INPUT,
        validation: [Validators.minLength(4),Validators.required],
    },
    // fantasia - input
    {
        label: 'FANTASIA',
        name: 'tradingName',
        type: TypeComponentFieldEnum.INPUT,
        validation: [Validators.required, Validators.minLength(4)],
    },

    // incr. municipal - number
    {
        label: 'INCR. MUNICIPAL',
        name: 'municipalRegistration',
        type: TypeComponentFieldEnum.INPUT_NUMBER,
    },


    // celular - input phone
    {
        label: 'CELULAR',
        name: 'cellPhone',
        type: TypeComponentFieldEnum.INPUT_CELLPHONE,
        validation: [Validators.required, Validators.minLength(11)],
    },
    // telefone - input phone
    {
        label: 'TELEFONE',
        name: 'phone',
        type: TypeComponentFieldEnum.INPUT_PHONE,
    },
    {
        label: 'EMAIL',
        name: 'email',
        type: TypeComponentFieldEnum.INPUT_EMAIL,
        validation: [Validators.required, Validators.minLength(14)],
    },
    // web site - input
    {
        label: 'WEB SITE',
        name: 'webSite',
        type: TypeComponentFieldEnum.INPUT,
    },
    {
        type: TypeComponentFieldEnum.SELECT,
        label: 'TIPO CONTRIBUINTE',
        name: 'contributorType',
        value: ContributorTypeEnum.CONTRIBUTOR,
        options: Object.values(ContributorTypeEnum),
        placeholder: 'Selecione uma opção',
        validation: [Validators.required],
    },
    {
        type: TypeComponentFieldEnum.SELECT,
        label: 'REGIME',
        name: 'regime',
        value: RegimeTypeEnum.SIMPLE,
        options: Object.values(RegimeTypeEnum),
        placeholder: 'Selecione uma opção',
        validation: [Validators.required],
    },
    // atividade principal - input
    {
        label: 'ATIVIDADE',
        name: 'mainActivity',
        type: TypeComponentFieldEnum.INPUT,
        validation: [Validators.required, Validators.minLength(4)],
    },
    // ambiente fiscal - select
    {
        type: TypeComponentFieldEnum.SELECT,
        label: 'AMBIENTE FISCAL',
        name: 'fiscalEnvironment',
        options: Object.values(FiscalEnvironmentEnum),
        placeholder: 'Selecione uma opção',
        validation: [Validators.required],
    },
    {
        label: 'CSC',
        name: 'csc',
        type: TypeComponentFieldEnum.INPUT,
    },
    // ID CSC
    {
        label: 'ID CSC',
        name: 'cscId',
        type: TypeComponentFieldEnum.INPUT_NUMBER,
    },
    {
        type: TypeComponentFieldEnum.INPUT_CEP,
        label: 'CEP',
        name: 'cep',
        placeholder: 'Insira o CEP',
        validation: [Validators.required, Validators.minLength(7)],
    },

    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'UF',
        name: 'state',
        placeholder: 'Digite a UF do estado',
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'CIDADE',
        name: 'city',
        placeholder: 'Digite o nome da cidade',
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'ENDEREÇO',
        name: 'address',
        placeholder: 'Insira o endereço',
        validation: [Validators.required, Validators.minLength(4)],
    },
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'COMPLEMENTO',
        name: 'addressComplement',
        placeholder: 'Insira o complemento se houver',
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.INPUT_NUMBER,
        label: 'Nº',
        name: 'addressNumber',
        placeholder: 'INSIRA O NÚMERO CASO HOUVER',
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'BAIRRO',
        name: 'neighborhood',
        placeholder: 'Insira o bairro',
        validation: [Validators.required, Validators.minLength(4)],
    },
    {
        label: 'FOTO/LOGO',
        name: 'image',
        type: TypeComponentFieldEnum.INPUT_FILE_WITH_COMMENT_AND_DATE,
        validation: []
    }, 
    {
        label: 'FOTO DO DOCUMENTO',
        name: 'documentPhoto',
        type: TypeComponentFieldEnum.INPUT_FILE_WITH_COMMENT_AND_DATE,
        validation: []
    }, 
    {
        label: 'CERTIFICADO DIGITAL',
        name: 'digitalDocument',
        type: TypeComponentFieldEnum.INPUT_FILE_WITH_COMMENT_AND_DATE,
        validation: []
    }, 
    {
        type: TypeComponentFieldEnum.SELECT,
        label: 'TIPO',
        name: 'type',
        options: Object.values(SystemTypeEnum),
        placeholder: 'Selecione uma opção',
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.SELECT_ADVANCED_SEARCH,
        label: 'PLANOS',
        name: 'plan',
        options:[],
        displayValue: (item: any) => item.systemName + '  -  ' + 'T:' + item.terminalQuantity + '  -  ' + 'R$ ' + item.monthlyValue,
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.SELECT_ADVANCED_SEARCH,
        label: 'MODULOS(Opcional)',
        name: 'systemModule',
        options:[],
        display:'name',
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'QUANTIDADES TERMINAIS',
        name: 'terminalQuantity',
        disabled: true,
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'MENSALIDADE R$',
        name: 'monthlyValue',
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'VENCIMENTO',
        name: 'dueDate',
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'TAXA DE ADESÃO R$',
        name: 'adhesionFee',
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.HIDDEN,
        label: 'QTD DIAS',
        name: 'dueInDays',
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.HIDDEN,
        label: 'VR. DIAS',
        name: 'daysCountValue',
        validation: [],
    },
    {
        type: TypeComponentFieldEnum.INPUT_CURRENCY,
        label: 'IMPLANTAÇÃO R$',
        name: 'deploymentValue',
        placeholder: 'Caso não tenha Implantação, digite 0',
        validation: []
    },
    {
        type: TypeComponentFieldEnum.HIDDEN,
        label: 'Full Plan (objeto completo)',
        name: 'fullPlan',
    },
    {
        type: TypeComponentFieldEnum.HIDDEN,
        label: 'Flag de registro',
        name: 'registered',
        defaultValue: false,
    },
    {
        type: TypeComponentFieldEnum.HIDDEN,
        label: 'COMISSÃO',
        name: 'partnerCommission',
   },

];
